import { render, staticRenderFns } from "./AuthGroupsScopesAdmin.vue?vue&type=template&id=5a4e7bec&scoped=true&"
import script from "./AuthGroupsScopesAdmin.vue?vue&type=script&lang=js&"
export * from "./AuthGroupsScopesAdmin.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5a4e7bec",
  null
  
)

export default component.exports